/*
 * Section « Méthode en scroll ».
 *
 * Un IntersectionObserver repère l'étape qui traverse le milieu de l'écran et
 * active le visuel correspondant. Aucun calcul au scroll, donc aucun coût de
 * performance mesurable.
 *
 * Si le navigateur ne connaît pas IntersectionObserver, on ne fait rien : le
 * premier visuel reste affiché et la page reste lisible.
 */

class MethodeScroll extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('[data-methode-step]'));
    this.medias = Array.from(this.querySelectorAll('[data-methode-media]'));
    this.ticks = Array.from(this.querySelectorAll('[data-methode-tick]'));

    if (this.steps.length === 0 || typeof IntersectionObserver === 'undefined') return;

    this.setActive(0);

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      // Bande étroite au centre de l'écran : l'étape qui la traverse devient active.
      rootMargin: '-48% 0px -48% 0px',
      threshold: 0,
    });
    this.steps.forEach((step) => this.observer.observe(step));

    if (window.Shopify && window.Shopify.designMode) {
      this.onBlockSelect = this.onBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      this.setActive(this.steps.indexOf(entry.target));
    });
  }

  onBlockSelect(event) {
    const step = event.target.closest('[data-methode-step]');
    if (step && this.steps.includes(step)) this.setActive(this.steps.indexOf(step));
  }

  setActive(index) {
    if (index < 0 || index === this.activeIndex) return;
    this.activeIndex = index;

    this.medias.forEach((media, i) => {
      media.classList.toggle('is-active', i === index);
    });

    this.ticks.forEach((tick, i) => {
      tick.classList.toggle('is-active', i === index);
      tick.classList.toggle('is-done', i < index);
    });
  }
}

customElements.define('methode-scroll', MethodeScroll);
